'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var reactI18next = require('react-i18next');
var cx = require('classnames');
var AlloyButton = require('../alloy-button/AlloyButton.js');
var popup_module = require('./popup.module.scss.js');
var CloseIcon = require('../alloy-icon/CloseIcon.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var PopupContainer = react.forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.arrowClassName, arrowClassName = _c === void 0 ? '' : _c, children = _a.children, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.showCloseButton, showCloseButton = _e === void 0 ? false : _e, _f = _a.hideArrow, hideArrow = _f === void 0 ? false : _f, handleClose = _a.handleClose, id = _a.id, labelledBy = _a.labelledBy, _g = _a.role, role = _g === void 0 ? 'tooltip' : _g, closeButtonStyles = _a.closeButtonStyles, _h = _a.haveAnimation, haveAnimation = _h === void 0 ? false : _h;
    var t = reactI18next.useTranslation()[0];
    var getArrow = function () { return (jsxRuntime.jsx("div", tslib.__assign({ className: "".concat(popup_module.default['popper__arrow'], " ").concat(arrowClassName), "data-testid": "popperArrow", "data-popper-arrow": true }, { children: jsxRuntime.jsx("div", { className: "".concat(popup_module.default['popper__arrow'], " ").concat(popup_module.default['popper__arrow--inner'], " popup_inner-arrow") }) }))); };
    var getCloseButton = function () { return (jsxRuntime.jsx(AlloyButton.AlloyButton, tslib.__assign({ buttonType: "ghost", addClass: "".concat(popup_module.default['close'], " ").concat(closeButtonStyles !== null && closeButtonStyles !== void 0 ? closeButtonStyles : ''), onClick: handleClose, "aria-label": t('CLOSE') }, { children: jsxRuntime.jsx(CloseIcon.default, {}) }))); };
    return (jsxRuntime.jsxs("div", tslib.__assign({ "aria-labelledby": labelledBy, className: cx__default.default((_b = {},
            _b[popup_module.default['react-popper']] = true,
            _b[popup_module.default['z-index-100']] = true,
            _b[popup_module.default['react-popper--arrow-hidden']] = hideArrow,
            _b[popup_module.default['dropAnimation']] = haveAnimation,
            _b[className] = !!className,
            _b)), "data-testid": "popup", id: id, ref: ref, role: role }, { children: [!hideArrow && getArrow(), showCloseButton && getCloseButton(), jsxRuntime.jsx("div", { children: children && children })] })));
});
PopupContainer.displayName = 'PopupContainer';
var PopupContainer$1 = PopupContainer;

exports.default = PopupContainer$1;
//# sourceMappingURL=PopupContainer.js.map
